<div class="sign-up-container" [formGroup]="signUpForm">
    <div class="sign-up-view">
        <h2 class="sign-up-label">Sign up</h2>
        <div class="sign-up-form">
            <div class="sign-up-name">
                <ccdl-input
                    [labelName]="'First name'"
                    controlId="firstName"
                    [type]="'text'"
                    [control]="getControl('firstName')"
                    [displayErrors]="isSubmitTriggered"
                    [errorConfig]="firstNameErrorConfig"
                    autocomplete="given-name"></ccdl-input>
                <ccdl-input
                    [labelName]="'Last name'"
                    controlId="lastName"
                    [type]="'text'"
                    [control]="getControl('lastName')"
                    [displayErrors]="isSubmitTriggered"
                    [errorConfig]="lastNameErrorConfig"
                    autocomplete="family-name"></ccdl-input>
            </div>
            <ccdl-input [labelName]="'Email address'"
                controlId="emailAddress"
                [type]="'text'"
                [control]="getControl('email')"
                [displayErrors]="isSubmitTriggered"
                [errorConfig]="emailErrorConfig"
                autocomplete="email"></ccdl-input>
            <ccdl-input [labelName]="'Phone number'"
                controlId="phoneNumber"
                [type]="'phone'"
                [control]="getControl('phoneNumber')"
                [displayErrors]="isSubmitTriggered"
                [errorConfig]="phoneErrorConfig"
                autocomplete="tel"></ccdl-input>
            <ccdl-input [labelName]="'Password'"
                [showOrHideText]="true"
                [type]="'password'"
                controlId="password"
                [control]="getControl('password')"
                [displayErrors]="isSubmitTriggered"
                [errorConfig]="passwordErrorConfig"
                autocomplete="new-password"></ccdl-input>
            <ccdl-input [labelName]="'Confirm password'"
                [showOrHideText]="true"
                [type]="'password'"
                controlId="confirmPassword"
                [control]="getControl('confirmPassword')"
                [displayErrors]="isSubmitTriggered"
                [errorConfig]="confirmPasswordErrorConfig"
                autocomplete="new-password"></ccdl-input>
            <ccdl-input [labelName]="'Address Line1'"
                controlId="addressLineOne"
                [control]="getControl('addressLine1')"
                autocomplete="address-line1"></ccdl-input>
            <ccdl-input [labelName]="'Address Line2'"
                controlId="addressLineTwo"
                [control]="getControl('addressLine2')"
                autocomplete="address-line2"></ccdl-input>
            <div class="sign-up-select">
                <ccdl-single-select
                    [labelText]="'Country'"
                    [isDisabled]="false"
                    [placeHolder]="'Select country'"
                    [control]="getControl('country')"
                    [options]="countryOptions"
                    [displayErrors]="isSubmitTriggered"
                    [errorConfig]="countryErrorConfig"></ccdl-single-select>
                <ccdl-single-select
                    [labelText]="'State'"
                    [isDisabled]="false"
                    [placeHolder]="'Select state'"
                    [control]="getControl('state')"
                    [options]="stateOptions"
                    [isDisabled]="!getControl('country').value"
                    [displayErrors]="isSubmitTriggered"
                    [errorConfig]="stateErrorConfig"></ccdl-single-select>
            </div>
            <ccdl-input [labelName]="'Zip'"
                controlId="zip"
                [control]="getControl('zip')"
                type="world_zip"
                [displayErrors]="isSubmitTriggered"
                [errorConfig]="zipErrorConfig"
                autocomplete="postal-code"></ccdl-input>
        </div>
        <div class="sign-up-terms">
            <div class="sign-up-agree-checkbox">
                <ccdl-checkbox [id]="'rememberMe'"
                    [control]="getControl('rememberMe')"
                    [displayErrors]="isSubmitTriggered"
                    [errorConfig]="rememberMeErrorConfig">
                    <span class="agree-pad">By creating an account, I agree to
                        our </span>
                    <ccdl-link
                        [linkText]="'Privacy Policy'"
                        [linkUnderLine]="true"
                        (onClick)="onPrivacyClick()">
                    </ccdl-link>
                    <span class="and-pad"> and </span>
                    <ccdl-link
                        [linkText]="'Terms of use'"
                        [linkUnderLine]="true"
                        (onClick)="onTermsClick()">
                    </ccdl-link>
                </ccdl-checkbox>
            </div>
        </div>
        <div class="sign-up-btns">
            <ccdl-button
                [btnLabel]="'SIGN UP'"
                [size]="'lg'"
                (onClick)="signUpClick()"
                [btnType]="'primary'"></ccdl-button>
            <p class="sign-up-btn-link">
                <span>Already have an account? </span>
                <ccdl-link [linkText]="'Sign in'"
                    (onClick)="onSignInViewClick()"
                    [linkUnderLine]="true"></ccdl-link>
            </p>
        </div>
    </div>
</div>